import usePersistedState from "./usePersistedState";

const useFilters = (namespace) => {
  const [filters, setFilters] = usePersistedState<any>(
    {},
    namespace ?? "filters",
    null
  );

  const setFilter = (name, value) => {
    setFilters((oldFilters) => ({
      ...oldFilters,
      [name]: value,
    }));
  };
  const addFilters = (filters) => {
    setFilters((oldFilters) => ({
      ...oldFilters,
      ...filters,
    }));
  };

  const resetFilters = () => {
    setFilters({});
  };

  return {
    filters,
    setFilter,
    addFilters,
    setFilters,
    resetFilters,
  };
};

export default useFilters;
